import "@/App.css";

function App() {
  // The actual application UI is rendered directly inside public/index.html
  // (vanilla JS + Leaflet). React only mounts a hidden root element so the
  // CRA bundle does not interfere with the standalone DOM layout.
  return null;
}

export default App;
